<template>
    <div class="multiple-view-container">
        <div class="files-button" @click.prevent="showFiles = !showFiles">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-files"
                viewBox="0 0 16 16">
                <path
                    d="M13 0H6a2 2 0 0 0-2 2 2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2 2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 13V4a2 2 0 0 0-2-2H5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1zM3 4a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4z" />
            </svg>
            Dosyalar
        </div>
        <Transition name="fade">
            <div v-show="showFiles" class="files-container">
                <div v-for="file in files" :key="file.Id" class="files">
                    <FileDownloadLink ref="fileDownloadLink" @cannotPreview="showPreviewOptions"
                        :isPreviewing="file.IsPreviewing" :custom-style="true" :show-dropdown="false" :document="file"
                        @preview="showFilePreview"></FileDownloadLink>
                </div>
            </div>
        </Transition>
        <FilePreview v-if="currentViewingFile" :key="currentViewingFile.Id" :file="currentViewingFile"
            :viewer="viewer || viewerType" :customHeight="true" :multiple-view-enabled="true" @changeShowFiles="showFiles = !showFiles" @close="$emit('closeMultipleFilePreview')">
        </FilePreview>
        <div v-else-if="previewOptionsVisible" class="previewOptionsContainer">
            <button class="btn btn-danger unavaliableFileCloseButton" @click="$emit('closeMultipleFilePreview')"><svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_429_11083)">
                        <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_429_11083">
                        <rect width="24" height="24" fill="#fff"/>
                        </clipPath>
                    </defs>
                </svg></button>
            <p v-if="currentlyUnavailableFile.UnsignedFile">{{ currentlyUnavailableFile.UnsignedFile.FileName }}</p>
            <p v-else>{{ currentlyUnavailableFile.FileName }}</p>
            <p>Bu dosya görüntülenemiyor.</p>
            <p>Aşağıdaki butonu kullanarak dosyayı indirebilirsiniz.</p>
            <div>
                <button type="button" class="btn btn-primary" @click="downloadUnavailableFile">İndir</button>
            </div>
        </div>
        <div v-else class="loadingContainer">
            <div>Yükleniyor <img src="../assets/loading_blue.gif" alt=""></div>
        </div>
    </div>
</template>

<script>
import FilePreview from './FilePreview.vue';
import FileDownloadLink from './FileDownloadLink.vue';
import axios from 'axios';
export default {
    components: {
        FilePreview,
        FileDownloadLink
    },
    props: {
        files: {
            type: Array,
            default: null
        },
        viewerType: {
            type: String,
        },
        clickedFileId: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            showFiles: false,
            file: null,
            currentViewingFile: null,
            viewer: null,
            previewOptionsVisible: false,
            currentlyUnavailableFile: null
        };
    },
    mounted() {
        setTimeout(() => {
            this.openClickedFile()
        }, 200);
    },
    methods: {
        downloadUnavailableFile() {
            console.log(this.currentlyUnavailableFile)
            if (!this.currentlyUnavailableFile.IsAttachment) {
                axios.post(`/${this.currentlyUnavailableFile.UnsignedFile ? this.currentlyUnavailableFile.UnsignedFile.EntityType : this.currentlyUnavailableFile.EntityType}/createDocumentUrl/`, {
                    EntityId: this.currentlyUnavailableFile.EntityId,
                    DocumentId: this.currentlyUnavailableFile.Id,
                })
                    .then(x => {
                        console.log("createDocumentUrl Result:", x.data);
                        window.open(x.data.Data.Url);
                    })
                    .catch(x => window.processErrorResponse(x, this));
            }else{
                axios.post(`/${this.currentlyUnavailableFile.UnsignedFile ? this.currentlyUnavailableFile.UnsignedFile.EntityType : this.currentlyUnavailableFile.EntityType}/createAttachmentUrl/`, {
                    EntityId: this.currentlyUnavailableFile.EntityId,
                    AttachmentId: this.currentlyUnavailableFile.Id,
                })
                    .then(x => {
                        console.log("createAttachmentUrl Result:", x.data);
                        window.open(x.data.Data.Url);
                    })
                    .catch(x => window.processErrorResponse(x, this));
            }
        },
        showPreviewOptions(document, type) {
            this.currentViewingFile = null;
            this.viewer = type;

            this.files.map(x => x.IsPreviewing = false)
            if (this.files[0].Document) {
                if (document.Document.DocumentId) {
                    this.files.map(x => x.IsPreviewing = document.Document.DocumentId == x.Document.DocumentId ? true : false)
                } else {
                    this.files.map(x => x.IsPreviewing = document.Document.Id == x.Document.Id ? true : false)
                }
            } else {
                this.files.map(x => x.IsPreviewing = document.Id == x.Id ? true : false)
            }
            this.previewOptionsVisible = true;
            this.showFiles = false;
            this.currentlyUnavailableFile = document
            this.currentlyUnavailableFile.EntityId = document.UnsignedFile ? document.UnsignedFile.EntityId : document.EntityId;
        },
        openClickedFile() {
            var indexFunction;
            if (this.files[0].Document) {
                indexFunction = (file) => file.Document.DocumentId ? file.Document.DocumentId : file.Document.Id == this.clickedFileId;
            } else {
                indexFunction = (file) => file.Id == this.clickedFileId;
            }
            var index = this.files.findIndex(indexFunction)
            this.$refs.fileDownloadLink[index].$refs.customClick.click()
            this.showFiles = false;
        },
        showFilePreview(document, type, isFormatted) {
            this.files.map(x => x.IsPreviewing = false)
            if (this.files[0].Document) {
                if (document.Document.DocumentId) {
                    this.files.map(x => x.IsPreviewing = document.Document.DocumentId == x.Document.DocumentId ? true : false)
                } else {
                    this.files.map(x => x.IsPreviewing = document.Document.Id == x.Document.Id ? true : false)
                }
            } else {
                this.files.map(x => x.IsPreviewing = document.Id == x.Id ? true : false)
            }

            this.currentViewingFile = document;
            this.viewer = type;
            this.currentViewingFile.EntityId = document.UnsignedFile ? document.UnsignedFile.EntityId : document.EntityId;
            if (isFormatted)
                this.currentViewingFile.IsFormatted = true;
            else
                this.currentViewingFile.IsFormatted = false;

            this.showFiles = false;
        },
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to{
    opacity: 0;
}

.multiple-view-container {
    position: fixed;
    top: 0px;
    left: 0px;
    height: 100vh;
    width: 100vw;
    background-color: white;
}

.files-button {
    z-index: 9999999998;
    position: fixed;
    top: 73px;
    background-color: rgba(159, 209, 255, 0.685);
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    padding: 10px 20px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.files-container {
    width: auto;
    max-width: 95vw;
    z-index: 9999999998;
    position: fixed;
    top: 120px;
    padding: 10px;
    left: 10px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    border-radius: 5px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.previewOptionsContainer{
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    padding-top: 200px;
}
.unavaliableFileCloseButton{
    position: absolute;
    right:  10px;
    top: 76px;
}
</style>